// extracted by mini-css-extract-plugin
export default {"title":"BlogItem_title__FMuGA","desc":"BlogItem_desc__S8aZ9","author":"BlogItem_author__CwtX4","wrapper":"BlogItem_wrapper__sz5hW"};